import { List } from 'immutable';
import { quickbooksContactConstants } from '../constants';

export function quickbooks_contacts(state = {}, action) {
  switch (action.type) {
    case quickbooksContactConstants.QUICKBOOKS_CONTACT_LIST_LOADING:
      return {
        ...state,
        listLoading: true
      };
    case quickbooksContactConstants.QUICKBOOKS_CONTACT_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case quickbooksContactConstants.QUICKBOOKS_CONTACT_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: [],
        listError: action.error
      };

    case quickbooksContactConstants.QUICKBOOKS_CONTACT_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case quickbooksContactConstants.QUICKBOOKS_CONTACT_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const quickbooksContactIndex = state.items.findIndex(val => val.id == action.response.id);

      if (quickbooksContactIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(quickbooksContactIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case quickbooksContactConstants.QUICKBOOKS_CONTACT_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    default:
      return state;
  }
}
